// redux/slices/accountSettings/listener.ts
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { updateAdminProfile } from './actions';
import LocalStorageService, { LocalStorageKeys } from '../../../services/localStorageService';
import { User } from '../auth/types';

export const accountSettingsListener = createListenerMiddleware();

accountSettingsListener.startListening({
  actionCreator: updateAdminProfile.fulfilled,
  effect: (action) => {
    const updatedDetails = action.payload.data;

    const existingUser = LocalStorageService.get<User>(LocalStorageKeys.USER);
    if (!existingUser) return;

    LocalStorageService.set(LocalStorageKeys.USER, {
      ...existingUser,
      full_name: updatedDetails.user_full_name,
      username: updatedDetails.user_username,
      user_bio: updatedDetails.user_bio,
      profile_image: updatedDetails.user_profile_image,
    });
  },
});
